import { Organization, Recipient } from 'app/main/pages/edit-template/edit-template.dto';
import { GlobalService } from './global.service';

export function personFields(recipient: Recipient, globalService: GlobalService, is_enable = 0) {
    return [
        {
            id: 0,
            is_enable: 1,
            name: 'First name',
            value: recipient?.firstname ?? '',
            required: 1,
            validation: 0,
            is_default: 1
        },
        {
            id: 0,
            is_enable: 1,
            name: 'Last name',
            value: recipient?.lastname ?? '',
            required: 0,
            validation: 0,
            is_default: 1
        },
        {
            is_enable: 1,
            id: 0,
            name: 'Email',
            value: recipient?.email ?? '',
            required: 1,
            validation: 0,
            is_default: 1
        },
        {
            is_enable: is_enable,
            id: 0,
            name: 'Phone no',
            value: recipient?.phone_no ?? '',
            required: 0,
            validation: 0,
            is_default: 1
        },
        {
            is_enable: is_enable,
            id: 0,
            name: 'Personal ID number',
            value: recipient?.persnol_no ?? '',
            required: 0,
            validation: 0,
            is_default: 1
        },
        {
            is_enable: is_enable,
            id: 0,
            name: 'Address',
            value: recipient?.address ?? '',
            required: 0,
            validation: 0,
            is_default: 1
        },
        {
            is_enable: is_enable,
            id: 0,
            name: 'Zip code',
            value: recipient?.zipcode ?? '',
            required: 0,
            validation: 0,
            is_default: 1
        },
        {
            is_enable: is_enable,
            id: 0,
            name: 'City',
            value: recipient?.city ?? '',
            required: 0,
            validation: 0,
            is_default: 1
        },
    ]
}

export function organizationFields(organization: Organization, globalService: GlobalService, is_enable = 0) {
    return [
            {
                is_enable: 1,
                id: 0,
                name: 'Organization',
                value: organization?.name ?? '',
                required: 0,
                validation: 0,
                is_default: 1
            },
            {
                is_enable: 1,
                id: 0,
                name: 'Reg no',
                value: organization?.register_no ?? '',
                required: 0,
                validation: 0,
                is_default: 1
            },
            {
                id: 0,
                is_enable: is_enable,
                name: 'Phone no',
                value: organization?.phone ?? '',
                required: 0,
                validation: 0,
                is_default: 1
            },
            {
                id: 0,
                is_enable: is_enable,
                name: 'Address',
                value: organization?.address ?? '',
                required: 0,
                validation: 0,
                is_default: 1
            },
            {
                id: 0,
                is_enable: is_enable,
                name: 'Zip code',
                value: organization?.zipcode ?? '',
                required: 0,
                validation: 0,
                is_default: 1
            },
            {
                id: 0,
                is_enable: is_enable,
                name: 'City',
                value: organization?.city ?? '',
                required: 0,
                validation: 0,
                is_default: 1
            },
        ]
}